export const propPoliciesRoomsHc = {
  policies: {
    breadcrumb: `Datenschutzerklärung`,
    cloneTitleNoun: `Unterkunftsrichtlinien`,
    cloneItemNoun: `die Richtlinien`,
    editorHintLang: `Datenschutzerklärung auf {label}`,
    optional: `(optional)`,
    headingOpt1: `Überschrift 1`,
    headingOpt2: `Überschrift 2`,
    headingOpt3: `Überschrift 3`,
    headingNormal: `Normal`,
    tipBold: `Fett`,
    tipItalic: `Kursiv`,
    tipUnderline: `Unterstrichen`,
    tipListOrdered: `Nummerierte Liste`,
    tipListBullet: `Aufzählung`,
    tipLink: `Link`,
    tipQuote: `Zitat`,
    tipClean: `Formatierung entfernen`,
    charCount: `{count} Zeichen | {count} Zeichen`,
    saving: `Wird gespeichert…`,
    editorPlaceholder: `Schreiben Sie hier die Datenschutzerklärung auf {label}…`,
    errNoListing: `Inserat nicht gefunden.`,
    errLoad: `Die Datenschutzerklärung konnte nicht geladen werden.`,
    errEsRequired: `Die Richtlinie auf Spanisch ist erforderlich.`,
    saveSuccess: `Datenschutzerklärung erfolgreich gespeichert.`,
    saveError: `Fehler beim Speichern der Richtlinien.`,
  },
  rooms: {
    bulkTitle: `Zimmer als Stapel anlegen`,
    bulkSubtitle: `Erstellen Sie mehrere Zimmer einer Kategorie mit automatischem Code und optionaler Beschreibung.`,
    available: `Verfügbar: {count}`,
    willCreate: `Werden angelegt: {count}`,
    needTypeFirst: `Legen Sie zuerst mindestens eine <b>Zimmerkategorie</b> an, um Zimmer erzeugen zu können.`,
    labelType: `Kategorie`,
    selectType: `Kategorie auswählen`,
    labelQuantity: `Anzahl`,
    phQuantity: `Z. B.: 10`,
    labelPrefix: `Code-Präfix`,
    phPrefix: `Z. B.: A- oder 10`,
    optional: `Optional`,
    labelStart: `Start`,
    labelPadding: `Stellen`,
    labelDescription: `Beschreibung (optional)`,
    phDescription: `Wird auf die angelegten Zimmer angewendet`,
    nameEqType: `Name = Kategorie`,
    recommended: `(empfohlen)`,
    example: `Beispiel:`,
    createBulk: `Als Stapel anlegen`,
    typeFallback: `Kategorie`,
    previewFormat: `{name} • Code: {code}`,
    noActivePlan: `Sie haben keinen aktiven Tarif, um Zimmer anzulegen.`,
    limitReached: `Limit erreicht: Ihr Tarif erlaubt {limit} Zimmer für diese Unterkunft.`,
    selectTypeWarn: `Wählen Sie eine Zimmerkategorie aus.`,
    invalidQuantity: `Geben Sie eine gültige Anzahl ein.`,
    cannotAddMore: `Sie können keine weiteren hinzufügen. Limit: {limit}.`,
    partialCreated: `Es wurden nur {created} angelegt, da Ihr Tarif {limit} erlaubt und Ihnen noch {remaining} übrig waren.`,
    planLimitSave: `Ihr Tarif erlaubt {limit} Zimmer. Sie versuchen, {count} zu speichern.`,
  },
  images: {
    zipDownloadTitle: `Alle Bilder der Unterkunft als ZIP herunterladen`,
    zipNoImages: `Es gibt keine Bilder zum Herunterladen`,
    preparing: `Wird vorbereitet…`,
    downloadImages: `Bilder herunterladen`,
    loading: `Bilder werden geladen…`,
    noAccommodations: `Für diese Unterkunft wurden noch keine Einheiten eingerichtet.`,
    engineCoverTag: `Titelbild der Buchungsmaschine`,
    imageCount: `{count} Bild | {count} Bilder`,
    hotelPhotosDesc: `Allgemeine Fotos (Innenhof, Eingang, Rezeption…), die der Kunde beim Öffnen der Buchungsmaschine sieht`,
    dragToOrder: `Ziehen Sie, um die Galerie zu sortieren`,
    ordering: `Wird sortiert…`,
    dragTip: `Ziehen`,
    hotelSectionName: `Hotelfotos · Gemeinschaftsbereiche`,
    orderUpdated: `Bildreihenfolge aktualisiert.`,
    orderError: `Die Bildreihenfolge konnte nicht aktualisiert werden.`,
    downloadError: `Die Bilder konnten nicht heruntergeladen werden.`,
  },
};
